<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1000">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Grupo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="justify-center mt-7">
              <v-col cols="6">
                <v-select
                  v-model="content.origem"
                  label="Origem"
                  item-text="descricao"
                  item-value="id"
                  dense
                  outlined
                  return-object
                  :disabled="edit"
                  :items="form.lists.origens"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="content.nome"
                  label="Nome do Grupo"
                  maxLength="40"
                  counter="40"
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 40)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="content.descricao"
                  label="Descrição do Grupo"
                  maxlength="250"
                  counter="250"
                  rows="3"
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 250)]"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="isEscola">
              <v-col :cols="(isProfessor || isTecnicoFormador) ? 3 : 4">
                <v-select
                  v-model="content.greId"
                  item-text="nome"
                  item-value="codigo"
                  label="GRE"
                  dense
                  outlined
                  :items="form.lists.gres"
                ></v-select>
              </v-col>
              <v-col :cols="(isProfessor || isTecnicoFormador) ? 3 : 4">
                <v-autocomplete
                  :key="escolaKey"
                  v-model="content.escolaId"
                  item-text="nome"
                  item-value="codigo"
                  label="Escola"
                  dense
                  outlined
                  multiple
                  :items="form.lists.escolas"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 && content.escolaId && content.escolaId.length > 2" small class="ma-1">
                      {{ content.escolaId.length }} selecionados
                    </v-chip>
                    <v-chip v-else-if="!content.escolaId || content.escolaId.length <= 2" small class="ma-1">
                      {{ item.nome }}
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleTodasEscolas">
                      <v-list-item-action>
                        <v-icon :color="content.escolaId && content.escolaId.length > 0 ? 'primary' : ''">
                          {{ iconTodasEscolas }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Selecionar Todas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col :cols="(isProfessor || isTecnicoFormador) ? 3 : 4">
                <v-select
                  v-model="content.funcaoId"
                  item-text="nome"
                  item-value="id"
                  label="Função"
                  dense
                  outlined
                  :items="form.lists.funcoes"
                ></v-select>
              </v-col>
              <v-col v-if="isProfessor || isTecnicoFormador" cols="3">
                <v-autocomplete
                  :key="disciplinaKey"
                  v-model="content.disciplinaId"
                  item-text="nomeDisciplina"
                  item-value="id"
                  label="Disciplina"
                  dense
                  outlined
                  multiple
                  :items="form.lists.disciplinas"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 && content.disciplinaId && content.disciplinaId.length > 2" small class="ma-1">
                      {{ content.disciplinaId.length }} selecionados
                    </v-chip>
                    <v-chip v-else-if="!content.disciplinaId || content.disciplinaId.length <= 2" small class="ma-1">
                      {{ item.nomeDisciplina }}
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleTodasDisciplinas">
                      <v-list-item-action>
                        <v-icon :color="content.disciplinaId && content.disciplinaId.length > 0 ? 'primary' : ''">
                          {{ iconTodasDisciplinas }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Selecionar Todas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row v-if="isGRE">
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-autocomplete
                  v-model="content.greId"
                  item-text="nome"
                  item-value="codigo"
                  label="GRE"
                  dense
                  outlined
                  :items="form.lists.gres"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-autocomplete
                  v-model="content.setorId"
                  item-text="nome"
                  item-value="id"
                  label="Setor"
                  dense
                  outlined
                  :items="form.lists.setores"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-autocomplete
                  v-model="content.funcaoId"
                  item-text="nome"
                  item-value="id"
                  label="Função"
                  dense
                  outlined
                  :items="form.lists.funcoes"
                ></v-autocomplete>
              </v-col>
              <v-col v-if="isTecnicoFormador" cols="3">
                <v-autocomplete
                  :key="disciplinaKey"
                  v-model="content.disciplinaId"
                  item-text="nomeDisciplina"
                  item-value="id"
                  label="Disciplina"
                  dense
                  outlined
                  multiple
                  :items="form.lists.disciplinas"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 && content.disciplinaId && content.disciplinaId.length > 2" small class="ma-1">
                      {{ content.disciplinaId.length }} selecionados
                    </v-chip>
                    <v-chip v-else-if="!content.disciplinaId || content.disciplinaId.length <= 2" small class="ma-1">
                      {{ item.nomeDisciplina }}
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleTodasDisciplinas">
                      <v-list-item-action>
                        <v-icon :color="content.disciplinaId && content.disciplinaId.length > 0 ? 'primary' : ''">
                          {{ iconTodasDisciplinas }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Selecionar Todas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row v-if="isSEE">
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-autocomplete
                  v-model="content.secretariaId"
                  item-text="nome"
                  item-value="codigo"
                  label="Secretaria Executiva"
                  dense
                  outlined
                  :items="form.lists.secretarias"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-autocomplete
                  v-model="content.setorId"
                  item-text="nome"
                  item-value="id"
                  label="Setor"
                  dense
                  outlined
                  :items="form.lists.setores"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isTecnicoFormador ? 3 : 4">
                <v-select
                  v-model="content.funcaoId"
                  item-text="nome"
                  item-value="id"
                  label="Função"
                  dense
                  outlined
                  :items="form.lists.funcoes"
                ></v-select>
              </v-col>
              <v-col v-if="isTecnicoFormador" cols="3">
                <v-autocomplete
                  :key="disciplinaKey"
                  v-model="content.disciplinaId"
                  item-text="nomeDisciplina"
                  item-value="id"
                  label="Disciplina"
                  dense
                  outlined
                  multiple
                  :items="form.lists.disciplinas"
                  :rules="[(v) => $required(v)]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 && content.disciplinaId && content.disciplinaId.length > 2" small class="ma-1">
                      {{ content.disciplinaId.length }} selecionados
                    </v-chip>
                    <v-chip v-else-if="!content.disciplinaId || content.disciplinaId.length <= 2" small class="ma-1">
                      {{ item.nomeDisciplina }}
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleTodasDisciplinas">
                      <v-list-item-action>
                        <v-icon :color="content.disciplinaId && content.disciplinaId.length > 0 ? 'primary' : ''">
                          {{ iconTodasDisciplinas }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Selecionar Todas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            
            <div class="btn-group text-center mb-5">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" @click="adicionarTodosUsuariosAoGrupo()" v-bind="attrs" v-on="on">
                    <v-icon>mdi-account-plus</v-icon>
                  </v-btn>
                </template>
                <span>Incluir usuários em massa</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" @click="dialogAdicionarUsuario.open()" v-bind="attrs" v-on="on">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Incluir usuários</span>
              </v-tooltip>
            </div>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="content.usuarios"
                  :items-per-page="10"
                  :footer-props="$footerProps"
                >
                  <template v-slot:[`item.cpf`]="{ item }">
                    {{ $esconderCpf(item.cpf) }}
                  </template>
                  <template v-slot:[`item.acoes`]="{ item }">
                    <sigfoco-tooltip
                      text="Remover"
                      icon="mdi-trash-can-outline"
                      small
                      @click="removerUsuario(item)"
                    ></sigfoco-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          actionText="Salvar"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
    <AdicionarUsuarioDialog
      v-if="dialogAdicionarUsuario.visible"
      :visible="dialogAdicionarUsuario.visible"
      :content="dialogAdicionarUsuario.content"
      @onClose="dialogAdicionarUsuario.close()"
      @onSave="adicionarUsuarioAoGrupo($event)"
    ></AdicionarUsuarioDialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Dialog } from "~/commons/classes/dialog";
import { Grupo } from '~/commons/classes/grupo';
import OrigemEnum from '~/commons/enums/origem.enum';
import ManterFuncaoService from '@/services/manter-funcao.service';
import ManterGrupoService from '@/services/manter-grupo.service';
import ManterSetorService from '@/services/manter-setor.service';
import ManterDisciplinaService from '@/services/manter-disciplina.service';
import AuthService from '@/services/auth.service';
import AdicionarUsuarioDialog from './AdicionarUsuarioDialog.vue';

export default {
  props: new DialogProps(Grupo),
  components: {
    AdicionarUsuarioDialog
  },
  mixins: [
    ManterFuncaoService,
    ManterGrupoService,
    ManterSetorService,
    ManterDisciplinaService,
    AuthService
  ],
  computed: {
    isEscola() {
      return [OrigemEnum.ESCOLA].includes(this.content.origem?.id);
    },
    isGRE() {
      return [OrigemEnum.GRE].includes(this.content.origem?.id);
    },
    isSEE() {
      return [OrigemEnum.SEE].includes(this.content.origem?.id);
    },
    isProfessor() {
      const professorFunc = this.form.lists.funcoes.find(f => f.nome === "Professor");
      return professorFunc && professorFunc.id === this.content.funcaoId;
    },
    isTecnicoFormador() {
      const tecnicoFunc = this.form.lists.funcoes.find(f => f.nome === "Técnico Formador");
      return tecnicoFunc && tecnicoFunc.id === this.content.funcaoId;
    },
    iconTodasEscolas() {
      if (!Array.isArray(this.content.escolaId)) return 'mdi-checkbox-blank-outline';
      if (this.content.escolaId.length === 0) return 'mdi-checkbox-blank-outline';
      if (this.content.escolaId.length === this.form.lists.escolas.length) return 'mdi-close-box';
      return 'mdi-minus-box';
    },
    iconTodasDisciplinas() {
      if (!Array.isArray(this.content.disciplinaId)) return 'mdi-checkbox-blank-outline';
      if (this.content.disciplinaId.length === 0) return 'mdi-checkbox-blank-outline';
      if (this.content.disciplinaId.length === this.form.lists.disciplinas.length) return 'mdi-close-box';
      return 'mdi-minus-box';
    },
  },
  data: () => ({
    dialogAdicionarUsuario: Dialog.Build(),
    escolaKey: 0,
    disciplinaKey: 0,
    headers: [
      { text: 'CPF', value: 'cpf' },
      { text: 'Nome', value: 'nome' },
      { text: 'Cargo/Função', value: 'funcao' },
      { text: 'Ações', value: 'acoes', sortable: false }
    ],
    form: {
      lists: {
        origens: OrigemEnum.values(),
        gres: [],
        funcoes: [],
        secretarias: [],
        setores: [],
        escolas: [],
        disciplinas: []
      }
    },
  }),
  watch: {
    'content.origem': {
      handler() {
        // Limpar campos dependentes ao trocar a origem
        this.content.greId = null;
        this.content.escolaId = [];
        this.content.setorId = null;
        this.content.secretariaId = null;
        this.content.funcaoId = null;
        this.content.disciplinaId = [];
        this.form.lists.escolas = [];
        this.form.lists.setores = [];
        this.form.lists.secretarias = [];

        if (this.isSEE) {
          this.buscarSecretarias();
        }
        if (this.content.origem?.id) {
          this.buscarSetores(this.content.origem.id);
        }
      }
    },
    'content.funcaoId': {
      handler() {
        if (this.isProfessor || this.isTecnicoFormador) {
          this.buscarDisciplina();
        }
      }
    },
    "content.greId": function (novoGreId) {
      if (novoGreId) {
        this.carregarEscolas(novoGreId);
      }
    }
  },
  methods: {
    toggleTodasEscolas() {
      const todos = this.form.lists.escolas.map(e => e.codigo);
      const atual = Array.isArray(this.content.escolaId) ? this.content.escolaId : [];
      const todasSelecionadas = atual.length === todos.length && todos.length > 0;
      this.content.escolaId = todasSelecionadas ? [] : [...todos];
      this.escolaKey++;
    },
    toggleTodasDisciplinas() {
      const todos = this.form.lists.disciplinas.map(d => d.id);
      const atual = Array.isArray(this.content.disciplinaId) ? this.content.disciplinaId : [];
      const todasSelecionadas = atual.length === todos.length && todos.length > 0;
      this.content.disciplinaId = todasSelecionadas ? [] : [...todos];
      this.disciplinaKey++;
    },
    /**
     * Valida se os campos obrigatórios foram preenchidos, caso sim, busca e adiciona todos os usuários.
     * Caso seja uma Escola, é necessário preencher GRE, Escola e Função.
     * Caso seja uma GRE, é necessário preencher GRE, Setor e Função.
     * Caso seja uma SEE, é necessário preencher Secretaria, Setor e Função.
     */
    adicionarTodosUsuariosAoGrupo() {
      const validarCamposParaAdicionar = () => {
        return (this.isEscola && (this.content.greId && this.content.escolaId && this.content.funcaoId))
        || (this.isGRE && (this.content.greId && this.content.setorId && this.content.funcaoId))
        || (this.isSEE && (this.content.secretariaId && this.content.setorId && this.content.funcaoId));
      }
      if (validarCamposParaAdicionar()) {
        const payload = {
          ...this.content,
          origemId: this.content.origem?.id,
          origem: undefined,
        };
        this.$obterUsuariosGrupo(payload).then(({ data }) => {
          data.usuarios.forEach((u) => this.adicionarUsuarioAoGrupo(u));
          this.content.greId = null;
          this.content.escolaId = [];
          this.content.setorId = null;
          this.content.secretariaId = null;
          this.content.funcaoId = null;
          this.content.disciplinaId = [];
          this.form.lists.escolas = [];
          this.escolaKey++;
          this.disciplinaKey++;
        });
      }
    },
    adicionarUsuarioAoGrupo(usuario) {
      if (this.content.usuarios.some(u => u.usuarioId === usuario.usuarioId)) {
        return this.$notifyError(`Usuário ${usuario.nome} já adicionado ao grupo`);
      }
      this.content.usuarios.push(usuario);
    },
    removerUsuario(usuario) {
      return this.$swal({
        text: `Deseja confirmar essa operação?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.content.usuarios = this.content.usuarios.filter(u => u.usuarioId !== usuario.usuarioId);
        this.$notifySuccess('Operação realizada com sucesso');
      });
    },
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new Grupo(this.content).formatParaEnviar();
          return this.edit
            ? this.$editarGrupo(payload, payload.id)
            : this.$cadastrarGrupo(payload);
        });
      };

      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    buscarFuncoes() {
      this.$buscarFuncoes().then(({ data }) => this.form.lists.funcoes = data.itens);
    },
    buscarSecretarias() {
      this.$obterListaSecretarias().then(({ data }) => this.form.lists.secretarias = data.lista);
    },
    buscarSetores(origem) {
      this.$buscarSetores({ params: { origem } }).then(({ data }) => this.form.lists.setores = data.itens);
    },
    buscarDisciplina() {
      this.$buscarDisciplina().then(({ data }) => this.form.lists.disciplinas = data.lista);
    },
    buscarGerenciasRegionais() {
      this.$obterListaGerenciasRegionais().then(({ data }) => this.form.lists.gres = data.lista);
    },
    async carregarEscolas(greId) {
      try {
        const { data } = await this.$obterListaEscolas({gres: greId});
        this.form.lists.escolas = data.lista;
      } catch (error) {
        console.error("Erro ao carregar escolas:", error);
      }
    }
  },
  mounted() {
    this.buscarFuncoes();
    this.buscarSecretarias();
    this.buscarGerenciasRegionais();
    this.buscarDisciplina();
  }
}
</script>